import { handleSearch } from "./handler";
import { useSearchStore } from "./store";


export const performSearch = (query: string) => {
  const { setChats, setMessages, setPageChats, setPageMessages, setHasMoreChats, setHasMoreMessages } = useSearchStore.getState();

  // сбрасываем стейт перед новым поиском
  setChats([]);
  // setMessages([]);
  setPageChats(1);
  // setPageMessages(1);
  setHasMoreChats(true);
  setHasMoreMessages(true);

  // вызываем хендлер поиска
  handleSearch(query, true);
};
